import { Stack } from '@mui/material'
import React from 'react'
import ParentCellOrFragment from './ParentCellOrFragment'
import ValueCell, { ValueCellProps } from './ValueCell'

type ValueCellWithButtonProps = {
  actionButton?: React.ReactNode
} & ValueCellProps

const ValueCellWithButton: React.FC<ValueCellWithButtonProps> = ({ actionButton, ...props }) => {
  return (
    <ParentCellOrFragment disableCell={props.disableCell} width={props.width}>
      <Stack px={2} direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
        <ValueCell {...props} disableCell />
        {actionButton}
      </Stack>
    </ParentCellOrFragment>
  )
}

export default ValueCellWithButton
